/* eslint-disable */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import gql from 'graphql-tag'
import { Query, withApollo, Subscription } from 'react-apollo'
import SubscriptionDetails from './subscriptionDetails.jsx'
import Typography from '@material-ui/core/Typography'
import MUIDataTable from 'mui-datatables'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import getAccountType from '../../../utils/getAccountType.js'
import Loader from '../../../components/common/Loader'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'

const GET_CLIENT = gql`
  query clientDetail($loginId: Int) {
    clientDetail(loginId: $loginId) {
      id
      clientName
      contactPerson
      address
      city
      gst
      state {
        name
      }
      country {
        name
      }
      email
      contactNumber
      loginId
      totalAssignedVehicle
      type
      solution
    }
  }
`
const GET_SUBSCRIPTION = gql`
  query getSubscriptions($subscriptionId: Int) {
    subscription: getSubscriptions(id: $subscriptionId) {
      id
      status
      billingDetails {
        paymentId
      }
    }
  }
`

const GET_SUBSCRIPTION_INVENTORY = gql`
  query getSubscriptionInventoryAssign($subscriptionId: Int!,$clientLoginId:Int) {
    subscription: getSubscriptionInventoryAssign(
      subscriptionId: $subscriptionId
      clientLoginId: $clientLoginId
    ) {
      id
      assignedDeviceDetails {
        serial_num
        imei_num
        uniqueDeviceId
        vehicleDetails {
          vehiclenumber
        }
        status
      }
      asignedSimDetails {
        phoneNumber
        simNumber
        vehicleDetails {
          vehiclenumber
        }
        status
      }
    }
  }
`

// const GET_SUBSCRIPTION = gql`
// query(){
//   getSubscriptions
// }
// `
const DEASSIGNSIM_FROM_SUBSCRIPTION = gql`
  mutation deassignSimFromSubscription(
    $phoneNumber: String!
    $simNumber: String!
    $subscriptionId: Int!
  ) {
    deassignSimFromSubscription(
      phoneNumber: $phoneNumber
      simNumber: $simNumber
      subscriptionId: $subscriptionId
    )
  }
`

const DEASSIGN_DEVICE_FROM_SUBSCRIPTION = gql`
  mutation deassignDeviceFromSubscription(
    $serial_num: String!
    $imei_num: String!
    $subscriptionId: Int!
  ) {
    deassignDeviceFromSubscription(
      serial_num: $serial_num
      imei_num: $imei_num
      subscriptionId: $subscriptionId
    )
  }
`

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 2
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  input: {
    display: 'none'
  },
  breakWord: {
    wordBreak: 'break-all'
  }
})

class ViewSubscription extends Component {
  constructor(props) {
    super(props)
    this.loginId = parseInt(this.props.match.params.loginId, 10)
    this.subscriptionId = parseInt(this.props.match.params.subscriptionId, 10)
    this.state = {
      deviceList: [],
      simList: [],
      openEdit: false,
      openEditDevice: false,
      simNo: '',
      phoneNo: '',
      serialNum: '',
      imeiNum: ''
    }
  }

  columns1 = [
    'SERIAL NUMBER',
    'IMEI NUMBER',
    'UNIQUE DEVICE ID',
    'VEHICLE NUMBER',
    {
      name: 'Status',
      options: { display: false }
    }
  ]
  columns2 = [
    'PHONE NUMBER',
    'SIM NUMBER',
    'VEHICLE NUMBER',
    {
      name: 'Status',
      options: { display: false }
    }
  ]

  options1 = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 5,

    onRowClick: (rowData, dataIndex, rowIndex) => {
      if (['INV', 'PA'].includes(getAccountType())) {
        if (rowData[4] && rowData[4] === 3) {
          this.handleClickOpenEditDevice()
          this.setState({
            serialNum: rowData[0],
            imeiNum: rowData[1]
          })
        }
      }
    }
  }

  options2 = {
    selectableRows: false,
    responsive: 'scroll',
    rowsPerPage: 5,
    onRowClick: (rowData, dataIndex, rowIndex) => {
      if (['INV', 'PA'].includes(getAccountType())) {
        if (rowData[3] && rowData[3] === 3) {
          this.handleClickOpenEdit()
          this.setState({ simNo: rowData[1], phoneNo: rowData[0] })
        }
      }
    }
  }

  handleClickOpenEdit = () => {
    this.setState({ openEdit: true })
  }

  handleClickOpenEditDevice = () => {
    this.setState({ openEditDevice: true })
  }

  handleCloseEdit = () => {
    this.setState({ openEdit: false })
  }

  handleCloseEditDevice = () => {
    this.setState({ openEditDevice: false })
  }

  editCustomer = loginId => e => {
    this.props.history.push({
      pathname: '/home/customers/edit/' + loginId
    })
  }

  editSubscription = e => {
    this.props.history.push({
      pathname:
        '/home/subscriptions/edit/' + this.loginId + '/' + this.subscriptionId
    })
  }

  /*
  ##### For Statu Code 1, 3, and 4 Edit button will be invisisble.
      CODE  STATUS
        1 - Pending
        2 - Approved and partial payment
        3 - Rejected
        4 - Pending of already approved subscription.
        5 - Approved and fully paid
  #####
  */
  getSubscriptionData = async () => {
    const { data } = await this.props.client.query({
      query: GET_SUBSCRIPTION,
      variables: {
        subscriptionId: this.subscriptionId
      },
      // fetchPolicy: 'network-only'
    })
    console.log('subcription data is called', data.subscription)
    const { subscription } = data
    if (subscription !== null) {
      const { status, billingDetails } = subscription
      this.setState({
        paymentId: billingDetails ? billingDetails.paymentId : 0
      })
      if (status == 2 || status == 5) {
        this.setState({ isEditButton: true })
      } else {
        this.setState({ isEditButton: false })
      }
    }
  }

  showSubscription = value => e => {
    // this.props.history.push({
    //   pathname: '/home/subscriptions/view-detail/' + this.subscriptionId
    // })
  }

  mapToArr = data => {
    let rowData = []
    let fullData = []
    this.entityId = []
    data.forEach(element => {
      rowData = []
      // this.entityId.push(element.entityId)
      rowData.push(element.serial_num)
      rowData.push(element.imei_num)
      rowData.push(element.uniqueDeviceId)
      if (element.vehicleDetails !== null) {
        rowData.push(element.vehicleDetails.vehiclenumber)
      } else {
        rowData.push('NA')
      }
      rowData.push(element.status)

      fullData.push(rowData)
    })
    this.setState({ deviceList: fullData })
    return fullData
  }

  mapToSimArr = data => {
    let rowData = []
    let fullData = []
    data.forEach(element => {
      rowData = []
      rowData.push(element.phoneNumber)
      rowData.push(element.simNumber)
      if (element.vehicleDetails !== null) {
        rowData.push(element.vehicleDetails.vehiclenumber)
      } else {
        rowData.push('NA')
      }
      rowData.push(element.status)

      fullData.push(rowData)
    })
    this.setState({ simList: fullData })
    return fullData
  }

  getSubscriptionInventory = async () => {
    try{
      const { data } = await this.props.client.query({
        query: GET_SUBSCRIPTION_INVENTORY,
        variables: {
          subscriptionId: parseInt(this.subscriptionId, 10),
          clientLoginId: parseInt(this.loginId, 10),
        },
        // fetchPolicy: 'network-only'
      })
      this.setDetails(data.subscription)
    } catch(error) {
      let errorMessage = error.message.split(":")
      this.props.openSnackbar(errorMessage[1])
    }
    
  }

  deassignSim = async event => {
    event.preventDefault()
    console.log(
      'deassign sims states',
      this.state.phoneNo,
      this.state.simNo,
      this.subscriptionId
    )
    const { data, errors } = await this.props.client.mutate({
      mutation: DEASSIGNSIM_FROM_SUBSCRIPTION,
      variables: {
        phoneNumber: this.state.phoneNo,
        simNumber: this.state.simNo,
        subscriptionId: this.subscriptionId
      },
      errorPolicy: 'all'
    })
    console.log('submit', errors)
    if (data != null && data.deassignSimFromSubscription === true) {
      this.handleCloseEdit()
      this.props.openSnackbar('Sim Deassigned Successfully')
      this.getSubscriptionInventory()
    } else {
      this.props.openSnackbar(errors[0].message)
    }
  }

  deassignDevice = async event => {
    event.preventDefault()
    const { data } = await this.props.client.mutate({
      mutation: DEASSIGN_DEVICE_FROM_SUBSCRIPTION,
      variables: {
        serial_num: this.state.serialNum,
        imei_num: this.state.imeiNum,
        subscriptionId: this.subscriptionId
      },
      errorPolicy: 'all'
    })
    // console.log('submit', data)
    if (data != null && data.deassignDeviceFromSubscription === true) {
      this.handleCloseEditDevice()
      this.props.openSnackbar('Device Deassigned Successfully')
      this.getSubscriptionInventory()
    } else {
      this.props.openSnackbar('Error in deassigning Device')
    }
  }

  setDetails = inventoryDetails => {
    if (inventoryDetails) {
      if (inventoryDetails.assignedDeviceDetails.length > 0) {
        this.mapToArr(inventoryDetails.assignedDeviceDetails)
      }
      if (inventoryDetails.asignedSimDetails.length > 0) {
        this.mapToSimArr(inventoryDetails.asignedSimDetails)
      }
    }
  }

  componentDidMount() {
    this.getSubscriptionInventory()
    this.getSubscriptionData()
  }
  render() {
    const { classes } = this.props
    const { isEditButton } = this.state
    return (
      <Fragment>
        <Query
          query={GET_CLIENT}
          variables={{
            loginId: parseInt(this.loginId, 10)
          }}
          // fetchPolicy="network-only"
        >
          {({ loading, error, data }) => {
            if (loading) return <Loader />
            if (error) return `Error!: ${error}`

            return (
              <div className={classes.root}>
                <Grid container spacing={16} direction="row">
                  <Grid item xs={12}>
                    <Grid container justify="space-between">
                      <Grid item>
                        <Button
                          variant="outlined"
                          color="secondary"
                          className={classes.button}
                          onClick={() => this.props.history.goBack()}
                        >
                          <ArrowBackIcon className={classes.iconSmall} />
                        </Button>
                      </Grid>
                      <Grid item>
                        {!['INV', 'ACC'].includes(getAccountType()) && (
                          <Grid container spacing={8} justify="flex-end">
                            <Grid item xs={12} sm="auto">
                              {this.state.isEditButton && (
                                <Button
                                  variant="raised"
                                  color="secondary"
                                  className={classes.button}
                                  onClick={this.editSubscription}
                                >
                                  Edit
                                </Button>
                              )}
                            </Grid>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="display1" gutterBottom>
                      &nbsp;
                      {data.clientDetail.clientName}
                      {console.log(data.subscription)}
                    </Typography>
                  </Grid>
                  {/* Place the corresponding subscription card */}
                  {/* <Grid item container spacing={16} direction="row"> */}
                  <Grid item xs={12}>
                    <SubscriptionDetails
                      clientDetail={data.clientDetail}
                      showSubscription={this.showSubscription}
                      subscriptionId={this.subscriptionId}
                      clientLoginId={this.loginId}
                      isDisabled={true}
                      paymentId={this.state.paymentId}
                    />
                    {/* </Grid> */}
                    {/* </Grid> */}
                  </Grid>

                  {['SAL', 'PA', 'INV'].includes(getAccountType()) && (
                    <Grid item xs={12}>
                      {/* TODO: Replace this with a custom table going forward */}
                      {this.state.deviceList && (
                        <MUIDataTable
                          title="Assigned Devices"
                          data={this.state.deviceList}
                          columns={this.columns1}
                          options={this.options1}
                        />
                      )}
                    </Grid>
                  )}
                  {['SAL', 'PA', 'INV'].includes(getAccountType()) && (
                    <Grid item xs={12}>
                      {/* TODO: Replace this with a custom table going forward */}
                      {this.state.simList && (
                        <MUIDataTable
                          title="Assigned SIMs"
                          data={this.state.simList}
                          columns={this.columns2}
                          options={this.options2}
                        />
                      )}
                    </Grid>
                  )}

                  <Dialog
                    open={this.state.openEditDevice}
                    onClose={this.handleCloseEditDevice}
                    aria-labelledby="form-dialog-title"
                  >
                    <Grid>
                      <DialogTitle id="alert-dialog-title">
                        {
                          'Are you sure you want to Deassign this Device from the Subscription?'
                        }
                      </DialogTitle>
                      <DialogActions>
                        <Button
                          onClick={this.handleCloseEditDevice}
                          color="primary"
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={this.deassignDevice}
                          color="primary"
                          autoFocus
                        >
                          Deassign
                        </Button>
                      </DialogActions>
                    </Grid>
                  </Dialog>
                  <Dialog
                    open={this.state.openEdit}
                    onClose={this.handleCloseEdit}
                    aria-labelledby="form-dialog-title"
                  >
                    <Grid>
                      <DialogTitle id="alert-dialog-title">
                        {
                          'Are you sure you want to Deassign this sim from the Subscription?'
                        }
                      </DialogTitle>
                      <DialogActions>
                        <Button onClick={this.handleCloseEdit} color="primary">
                          Cancel
                        </Button>
                        <Button
                          onClick={this.deassignSim}
                          color="primary"
                          autoFocus
                        >
                          Deassign
                        </Button>
                      </DialogActions>
                    </Grid>
                  </Dialog>
                </Grid>
              </div>
            )
          }}
        </Query>
      </Fragment>
    )
  }
}

ViewSubscription.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(
  withApollo(withSharedSnackbar(ViewSubscription))
)



// WEBPACK FOOTER //
// ./src/components/Pages/ViewSubscription/index.jsx